import { render, staticRenderFns } from "./PaginatedDocumentList.vue?vue&type=template&id=ceb01148"
import script from "./PaginatedDocumentList.vue?vue&type=script&lang=ts"
export * from "./PaginatedDocumentList.vue?vue&type=script&lang=ts"
import style0 from "./PaginatedDocumentList.vue?vue&type=style&index=0&id=ceb01148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports